import { useState, useRef } from 'react';
import Slider from 'react-slick';
import usePlatform from '../../hooks/usePlatform';
import { CursorPagination } from '../../components/Common/cursor-pagination';
import './trantor-stats.scss';

interface StatItem {
  title?: string;
  value?: string;
  label: string | React.ReactNode;
  img: string;
}

interface TrantorStatsProps {
  items: StatItem[];
  style?: React.CSSProperties;
  styleCard?: React.CSSProperties;
  renderItem?: (item: StatItem) => React.ReactNode;
}

export default ({ items, style, styleCard, renderItem }: TrantorStatsProps) => {
  const { isPc } = usePlatform() || {};
  const [mobileIndex, setMobileIndex] = useState(0);
  const sliderRef = useRef<Slider>(null);

  if (isPc) {
    return (
      <div className="trantor-stats" style={style}>
        <ul>
          {items.map((item, index) => (
            <li key={index}>
              {renderItem ? renderItem(item) : (
                <>
                  <div className="stat-value-wrap">
                    {item.title && <span className="stat-title">{item.title}</span>}
                    {item.value && <span className="stat-value">{item.value}</span>}
                  </div>
                  <span className="stat-label" style={item.title ? { fontSize:  '14px', height: '88px', width: '252px', textAlign: 'left', marginTop: '12px' } : undefined}>{item.label}</span>
                  <img className="stat-img" src={item.img} />
                </>
              )}
              {index < items.length - 1 && <div className="stat-divider" style={item.title ? { height: '261px' } : undefined}/>}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  // 移动端使用 Slider
  const settings = {
    infinite: true,
    swipe: true,
    autoplay: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    cssEase: 'ease-out',
    rows: 1,
    arrows: false,
    beforeChange: (_current: number, next: number) => {
      setMobileIndex(next);
    },
    centerPadding: '0px'
  };

  return (
    <div className="trantor-stats trantor-stats-mobile" style={style}>
      <Slider ref={sliderRef} {...settings}>
        {items.map((item, index) => (
          <div key={index}>
            {renderItem ? renderItem(item) : (
              <div className="stat-card" style={styleCard}>
                <div className="stat-value-wrap">
                  {item.title && <span className="stat-title">{item.title}</span>}
                  {item.value && <span className="stat-value">{item.value}</span>}
                </div>
                <span className="stat-label">{item.label}</span>
                <img className="stat-img" src={item.img} />
              </div>
            )}
          </div>
        ))}
      </Slider>
      <div className="trantor-stats-pagination">
        <CursorPagination
          count={items.length}
          activeIndex={mobileIndex}
        />
      </div>
    </div>
  );
};